import { forwardRef } from "react";
import {
  ControllerProps,
  ControllerRenderProps,
  FieldValues,
} from "react-hook-form";
import DatePickerInput from "components/Shared/Forms/DatePicker";

type Props = Omit<ControllerRenderProps<FieldValues, string>, "ref">;

const DateFilterInput = forwardRef<HTMLInputElement, Props>((props, ref) => (
  <DatePickerInput ref={ref} {...props} portalId="date-picker" />
));

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
DateFilterInput.displayName = "DateFilterInput";

export default DateFilterInput;

export const DateTimeFilterInput = forwardRef<HTMLInputElement, Props>(
  (props, ref) => (
    <DatePickerInput
      ref={ref}
      {...props}
      portalId="date-picker"
      showTimeInput
    />
  ),
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
DateTimeFilterInput.displayName = "DateTimeFilterInput";

export const renderDateFilterInput: ControllerProps["render"] = ({ field }) => (
  <DateFilterInput {...field} />
);

export const renderDateTimeFilterInput: ControllerProps["render"] = ({
  field,
}) => <DateTimeFilterInput {...field} />;
